/**
 * Badge-Primitive — kleine Mono-Pille mit semantischer Farb-Tone.
 * Quelle: §10.18 Extraktion aus project-detail.tsx (Primitives-Block).
 */
import type { ReactNode } from 'react';

export type BadgeTone = 'primary' | 'info' | 'warn' | 'danger' | 'success';

export function Badge({
  children,
  tone,
  title,
}: {
  children: ReactNode;
  tone: BadgeTone;
  /** Optionaler Tooltip (z. B. Art/Datum/Grund bei `FinalBadge`). */
  title?: string | undefined;
}) {
  const bg =
    tone === 'primary'
      ? 'var(--primary-soft)'
      : tone === 'info'
        ? 'var(--info-soft)'
        : tone === 'warn'
          ? 'var(--warn-soft)'
          : tone === 'danger'
            ? 'var(--danger-soft)'
            : 'var(--success-soft)';
  const fg =
    tone === 'primary'
      ? 'var(--primary)'
      : tone === 'info'
        ? 'var(--info-strong)'
        : tone === 'warn'
          ? 'var(--warn)'
          : tone === 'danger'
            ? 'var(--danger)'
            : 'var(--success)';
  return (
    <span
      title={title}
      className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] uppercase tracking-[0.1em]"
      style={{ background: bg, color: fg, fontFamily: 'var(--f-mono)' }}
    >
      {children}
    </span>
  );
}
